<div class="sp-search-container" *ngIf="!isLoading">
  <div class="lateral-filters">
    <app-list-filter #listFilter [isCloseButtonVisible]="false" [mode]="'Search'" [isMultiplePropertyFilterVisible]="true" [items]="allItems" [properties]="properties" (filterChanged)="filterChanged($event)"></app-list-filter>
  </div>

  <div class="search-results">
    <div class="search-results-header">
      <span class="results-label">Showing {{resultCount}} {{itemType}} for <strong>{{query}}</strong></span>
      <div class="sort-box">
        <div class="form-container">
          <h6 class="label">Sort by:</h6>
          <div class="select">
            <ng-select placeholder="sortedBy" [clearable]="false" [searchable]="false" [items]="sortOptions" [(ngModel)]="sortedBy" (change)="sort()" appendTo="body"></ng-select>
          </div>
        </div>
      </div>
    </div>

    <div>
      <ul ngbNav #nav="ngbNav" [(activeId)]="activeTabId" class="nav-tabs search-tabs">
        <li [ngbNavItem]="1">
          <a ngbNavLink>All</a>
          <ng-template ngbNavContent>
            <app-sp-search-results [items]="allFilteredItems"></app-sp-search-results>
          </ng-template>
        </li>
        <li [ngbNavItem]="2">
          <a ngbNavLink>Documents</a>
          <ng-template ngbNavContent>
            <app-sp-search-results [items]="allFilteredDocs"></app-sp-search-results>
          </ng-template>
        </li>
        <li [ngbNavItem]="3">
          <a ngbNavLink>Records</a>
          <ng-template ngbNavContent>
            <app-sp-search-results [items]="allFilteredRecords"></app-sp-search-results>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="nav"></div>
    </div>

    <div class="no-results" *ngIf="resultCount === 0">
      <img src="/assets/img/nosearchresult.png" alt="No Search Result">
          <p>Your search did not yield any relevant documents or records.<br>Try searching again by entering a document name, specifying other keywords, or modifying filters.</p>
    </div>
  </div>
</div>

<div class="home-tabs-loader" *ngIf="isLoading">
  <div class="loader"></div>
      <p>Searching for <strong>{{query}}</strong> ...</p>
</div>
